<div class="container" [class.has-own-sub-chrome]="!screenType">
    <ng-container *ngIf="!embedInRichClient">
        <dashboard-editor-sub-chrome [config]="dashboardViewSubChromeConfig" viewType="view"></dashboard-editor-sub-chrome>
    </ng-container>
    <div class="view-box">
        <tam-dashboard [options]="dashboardOptions"></tam-dashboard>
    </div>
</div>
